import { h, Fragment, RefObject } from "preact";

import EmojisHelpers from "../../../../apps/data/emojis/EmojisHelpers";
import classname from "../../../../foundation/utils/classname";
import { cmdKey } from "../../../../foundation/utils/keyboard";

import Popover, { PopoverMode, PopoverPosition } from "../../Popover";

import styles from "./ReactionsPopover.module.css";

interface Props {
    targetButton: RefObject<HTMLButtonElement>;
    onSelect(emoji: string, keepOpen: boolean): void;
    onClose(): void;
}

const REACTIONS = [
    "joy", "sob", "sweat_smile", "cry", "heart_eyes", "thinking_face", "shushing_face",
    "melting_face", "exploding_head", "smiling_imp", "sunglasses", "clown_face", "grimacing", "upside_down_face",
    "face_exhaling", "innocent", "face_with_monocle", "skull", "revolving_hearts", "thumbsup", "pinched_fingers",
    "muscle", "raised_hands", "clap", "pray", "white_check_mark", "x", "eyes",
    "nail_care", "otter", "orangutan", "frog", "dancer", "alien", "bomb",
    "brain", "popcorn", "baby_bottle", "rainbow", "sparkles", "nazar_amulet", "fire"
];

export default function ReactionsPopover({
    targetButton,
    onSelect,
    onClose
}: Props) {
    function handleSelect(event: MouseEvent, reaction: string) {
        onSelect(reaction, cmdKey(event));
    }

    function renderContent() {
        return (
            <>
                <h5 class={classname(styles.reactionsHeader, "body-1", "medium")}>Reactions</h5>
                <div class={styles.reactions}>
                    {REACTIONS.map(reaction => {
                        const emojiData = EmojisHelpers.searchEmoji(reaction, undefined);

                        if (emojiData === undefined) {
                            return null;
                        }

                        return (
                            <button
                                key={reaction}
                                type="button"
                                class={styles.reactionButton}
                                onClick={event => handleSelect(event, reaction)}>
                                {emojiData.emoji}
                            </button>
                        );
                    })}
                </div>
            </>
        );
    }

    return (
        <Popover
            class={styles.reactionsPopover}
            mode={PopoverMode.Portal}
            position={PopoverPosition.Bottom}
            offset={6}
            portalOptions={{
                targetRef: targetButton
            }}
            contentClass={styles.reactionsPopoverContent}
            content={renderContent()}
            open
            hasOverlay
            onClose={onClose}/>
    );
}
